// Currency / number formatting helpers — locale aware.

const LANG_TO_LOCALE = {
  en: "en-US",
  ar: "ar-AE",
  sv: "sv-SE",
};

export function localeFor(language) {
  return LANG_TO_LOCALE[language] || "en-US";
}

export function formatCurrency(amount, currency, language) {
  if (amount == null || isNaN(Number(amount))) return "—";
  const locale = localeFor(language);
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: (currency || "USD").toUpperCase(),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(amount));
  } catch {
    // Fall back if currency isn't recognized by Intl.
    return `${currency} ${Number(amount).toFixed(2)}`;
  }
}

export function formatPercent(value, language) {
  if (value == null || isNaN(Number(value))) return "—";
  const locale = localeFor(language);
  return new Intl.NumberFormat(locale, {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(value) / 100);
}

export function formatDate(value, language) {
  if (!value) return "—";
  const locale = localeFor(language);
  let d;
  try {
    // ISO date strings (YYYY-MM-DD) parsed in UTC; create a local Date to
    // avoid timezone drift around midnight.
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [y, m, day] = value.split("-").map(Number);
      d = new Date(y, m - 1, day);
    } else {
      d = new Date(value);
    }
  } catch {
    return String(value);
  }
  if (isNaN(d.getTime())) return String(value);
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(d);
}

// Curated list of common currencies users will pick from.
export const COMMON_CURRENCIES = [
  "SEK",
  "USD",
  "EUR",
  "GBP",
  "NOK",
  "DKK",
  "AED",
  "JPY",
  "CHF",
  "INR",
  "AUD",
  "CAD",
];
